import React, { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import { useLocation, useNavigate } from "react-router-dom";
import { SemesterContext } from "../context/SemesterContext";
import MinimalSelect from "./MinimalSelect";
import { LocationInterface } from "./UtilsComponents";
import { UserContext } from "../context/UserContext";

const SemesterSelect = () => {
  React.useEffect(() => {}, []);
  let location = useLocation() as LocationInterface;
  const screenClass = useScreenClass();
  const [visible, setVisible] = useState<boolean>(true);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [studentSemesters, setStudentSemesters] = useState(null);
  const semesterContext: any = useContext(SemesterContext);
  const userContext: any = useContext(UserContext);
  const navigate = useNavigate();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  // const selectedStudent = JSON.parse(
  //   localStorage.getItem("selectedStudent") as string
  // );
  // const [selectedStudent, setSelectedStudent] = useState<any>(
  //   localStorage.getItem("selectedStudent") as string
  // );

  useEffect(() => {
    // const allSemesters = [{ label: "All", value: "", year: "" }];
        const allSemesters :any = [];

    if (
      location.pathname === "/explore" ||
      location.pathname === "/explore/child" ||
      location.pathname === "/explore/child/competencies"
    ) {
      if (userContext.user.role === 1) {
        navigate("/explore");
      }
      if (
        !semesterContext.semesters.some(
          (elem: any) => elem.label === allSemesters[0]?.label
        )
      ) {
        semesterContext.setAllSemester(
          allSemesters.concat(semesterContext.semesters)
        );
      }
    } else {
      if (
        (location.pathname === "/student-roadmaps" ||
          location.pathname === "/student-credits" ||
          location.pathname === "/student-cards") &&
        semesterContext.selectedStudent
      ) {
        const stored = localStorage.getItem("selectedStudent");
        if (stored) {
          try {
            semesterContext.setSelectedStudent(JSON.parse(stored));
          } catch (e) {
            console.error("Failed to parse student", e);
          }
        }
        const index_of_first_term: any = semesterContext.semesters.indexOf(
          semesterContext.semesters.find(
            (v: any) => v.label === semesterContext.selectedStudent?.programs?.[0]?.term_entered
          )
        );

        const result = semesterContext.semesters?.slice(index_of_first_term);
        if(stored)
        setStudentSemesters(result);
        else{
          setStudentSemesters(null)
        }
      }
      let noAll = semesterContext.semesters.filter(
        (el: any) => el.label !== "All"
      );

      noAll?.length > 0
        ? semesterContext.setAllSemester(noAll)
        : semesterContext.setAllSemester(
            JSON.parse(localStorage.getItem("allSemesters") as string)
          );
      if (
        semesterContext.selectedSemester?.label === "All" &&
        noAll?.length > 0
      ) {
        semesterContext.setSemester(noAll[noAll.length - 1]);
      }
    }
    if (
      location.pathname === "/mycompetencies" ||
      location.pathname === "/help" ||
      location.pathname === "/calendar" ||
      location.pathname === "/student-cards" ||
      location.pathname === "/announcement" ||
      location.pathname === "/portfolio" ||
      location.pathname === "/profile" ||
      location.pathname === "/student-profile"
    ) {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, [semesterContext.selectedSemester, semesterContext.selectedStudent.id]);
  
 useEffect(() => {
  const handleChange = () => {
    const stored = localStorage.getItem("selectedStudent");

    if (!stored) {
      setStudentSemesters(null);
    }
  };

  window.addEventListener("selected-student-changed", handleChange);

  return () => {
    window.removeEventListener("selected-student-changed", handleChange);
  };
}, []);
  useEffect(() => {
    // const allSemesters = [{ label: "All", value: "", year: "" }];
    const allSemesters :any = [];

    setIsDisabled(false);
    if (
      location.pathname === "/explore" ||
      location.pathname === "/explore/child" ||
      location.pathname === "/explore/child/competencies"
    ) {
      if (
        !semesterContext.semesters.some(
          (elem: any) => elem?.label === allSemesters[0]?.label
        )
      ) {
        semesterContext.setAllSemester(
          allSemesters.concat(semesterContext.semesters)
        );
      }
    } else {
      let noAll = semesterContext.semesters.filter(
        (el: any) => el?.label !== "All"
      );
      semesterContext.setAllSemester(noAll);
      // if (semesterContext.selectedSemester?.label === "All") {
      //   semesterContext.setSemester(noAll[noAll.length - 1]);
      //   window.location.reload();
      // }
    }
    if (location.pathname.includes("/roadmap/detail")) {
      setIsDisabled(true); //disabled selector
    }
    if (
      location.pathname === "/mycompetencies" ||
      location.pathname === "/help" ||
      location.pathname === "/calendar" ||
      location.pathname === "/student-cards" ||
      location.pathname === "/announcement" ||
      location.pathname === "/portfolio" ||
      location.pathname === "/profile" ||
      location.pathname === "/student-profile"
    ) {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, [location]);


  const isInstructorOrAdmin = [2, 6].includes(userContext.user.role);

  return (
    <>
      {visible &&
        (semesterContext.semesters.length > 0 ? (
          <MinimalSelect
            isDisabled={isDisabled}
            setClass={isMobile ? "rs-container" : ""}
            placeholder="Select Semester"
            options={
              studentSemesters ? studentSemesters : semesterContext.semesters
            }
            value={semesterContext.selectedSemester}
            onChange={(data) => {
              semesterContext.setSemester(data);
            }}
          ></MinimalSelect>
        ) : isInstructorOrAdmin &&
          !semesterContext.semesterVersionsLoading ? (
          <div
            style={{
              color: "#c9c9c9",
              fontSize: 12,
              fontStyle: "italic",
              whiteSpace: "nowrap",
              padding: "6px 8px",
            }}
          >
            No semesters available for the selected program.
          </div>
        ) : null)}
    </>
  );
};

export default SemesterSelect;
